import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const ExpoGardeniasPopup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsOpen(true);
      setTimeout(() => setIsVisible(true), 50);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => setIsOpen(false), 300);
  };

  if (!isOpen) return null;

  return (
    <div
      className={`fixed inset-0 z-[60] flex items-center justify-center p-4 transition-all duration-300 ${
        isVisible ? 'bg-black/60 backdrop-blur-sm' : 'bg-transparent'
      }`}
      onClick={handleClose}
    >
      <div
        className={`relative w-full max-w-lg max-h-[90vh] overflow-y-auto transform transition-all duration-500 ${
          isVisible
            ? 'scale-100 opacity-100 translate-y-0'
            : 'scale-95 opacity-0 translate-y-8'
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="relative bg-white rounded-2xl shadow-2xl overflow-hidden">
          {/* Botón cerrar */}
          <button
            onClick={handleClose}
            className="absolute top-3 right-3 z-10 text-white bg-black/30 hover:bg-black/50 rounded-full p-1.5 transition-all duration-200"
            aria-label="Cerrar"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          {/* Imagen principal - object-contain sin forzar aspect-square: se ajusta a
              una altura máxima para que el popup completo (imagen + texto + botón)
              quepa en pantalla sin necesitar scroll. */}
          <img
            src="/images/expogardenias-popup.jpg"
            alt="ExpoGardenias Crea y Emprende"
            className="w-full max-h-[42vh] sm:max-h-[48vh] object-contain bg-white rounded-t-2xl"
          />

          {/* Contenido */}
          <div className="px-6 py-6 text-center">
            <h2 className="text-[#A52A2A] text-2xl font-bold tracking-tight mb-2">
              ExpoGardenias Crea y Emprende
            </h2>
            <p className="text-gray-600 text-sm mb-6">
              Conoce las fotos y videos de los proyectos de emprendimiento y creatividad de
              nuestros estudiantes en la galería de la institución.
            </p>
            <Link
              to="/expogardenias"
              onClick={handleClose}
              className="inline-block bg-[#A52A2A] hover:bg-[#8B2323] text-white px-6 py-2.5 rounded-lg text-sm font-semibold transition-colors duration-200 shadow-sm hover:shadow-md"
            >
              Ver galería
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpoGardeniasPopup;
